module.exports = __webpack_public_path__ + "static/media/glanbia-logo.14cce8b1.png";